import React from "react";
import { DatePicker, Form } from "antd";
import { useRootSelector } from "@/infrastructure/hooks";
import { BacktestAction, BacktestSel } from "@/features/backtest";
import moment from "moment";
import { useDispatch } from "react-redux";

const { RangePicker } = DatePicker;

export default () => {
  const dispatch = useDispatch();
  const startDate = useRootSelector(BacktestSel.startDate);
  const endDate = useRootSelector(BacktestSel.endDate);

  return (
    <Form.Item
      label="Select Period"
      name={"period"}
      rules={[{ required: true, message: "Please select the period!" }]}
      initialValue={[moment(startDate), moment(endDate)]}
    >
      <RangePicker
        style={{ width: "93%" }}
        onChange={e =>
          e &&
          e[1] &&
          e[0] &&
          dispatch(
            BacktestAction.updateSetup({ period: { start: e[0].format("YYYY-MM-DD"), end: e[1].format("YYYY-MM-DD") } })
          )
        }
        renderExtraFooter={() => "Select date range"}
      />
    </Form.Item>
  );
};
